import {PopupHint} from '@prtimes-basis/popup-hint';
import {HintIcon} from '@prtimes-basis/icons';
import {useId} from 'react';
import {FormRow} from '../form-row';
import {companyInfoFields} from '../../fields/company-info';
import {PublicBadge} from '../../../../components/public-badge';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function CompanyInformationSection() {
  const id = useId();
  const formTitleId = `${id}-formTitle`;

  return (
    <section
      aria-labelledby={formTitleId}
      className={companyRegistrationPageStyles.container}
    >
      <div className={companyRegistrationPageStyles.header}>
        <h2
          className={companyRegistrationPageStyles.formTitle}
          id={formTitleId}
        >
          企業情報
        </h2>

        <PopupHint
          content='代理店の方は、貴社のクライアントの情報をこちらにご記入ください。PRTIMES上にもプレスリリースの配信元として法人名などの情報が公開されます。'
          wrapperClassName={companyRegistrationPageStyles.popupHintOverride}
          defaultPosition={{vertical: 'top', horizontal: 'right'}}
        >
          <span className={companyRegistrationPageStyles.popupHintText}>
            代理店の方へ
          </span>
          <HintIcon variant='colored' />
        </PopupHint>
      </div>

      <div>
        <p className={companyRegistrationPageStyles.publicNotice}>
          ※ <PublicBadge />
          と表示されている項目は、企業登録後にPR
          TIMESサイト上で一般の方が閲覧できるようになります。
        </p>
      </div>

      <div className={companyRegistrationPageStyles.rows}>
        <FormRow
          isRequired
          isPublic
          labelText='法人名'
          htmlFor='companyInfo.corporateName'
        >
          <companyInfoFields.corporateNameField />
        </FormRow>

        <FormRow
          isRequired
          labelText='法人名（カナ）'
          htmlFor='companyInfo.corporateNameKana'
        >
          <companyInfoFields.corporateNameKanaField />
        </FormRow>

        <FormRow
          isRequired
          isPublic
          labelText='代表者名'
          htmlFor='companyInfo.presidentName'
        >
          <companyInfoFields.presidentNameField />
        </FormRow>

        <FormRow
          isRequired
          labelText='代表者役職'
          htmlFor='companyInfo.presidentTitle'
        >
          <companyInfoFields.presidentTitleField />
        </FormRow>

        <FormRow isPublic labelText='会社設立日'>
          <companyInfoFields.foundationField />
        </FormRow>

        <FormRow isRequired isPublic labelText='本社所在地'>
          <companyInfoFields.addressField />
        </FormRow>

        <FormRow isPublic labelText='代表電話番号'>
          <companyInfoFields.phoneNumberField />
        </FormRow>

        <FormRow
          isRequired
          isPublic
          labelText='上場区分'
          htmlFor='companyInfo.ipoKbn'
        >
          <companyInfoFields.ipoKbnField />
        </FormRow>

        <FormRow labelText='証券コード' htmlFor='companyInfo.securityCode'>
          <companyInfoFields.securityCodeField />
        </FormRow>

        <FormRow isPublic labelText='資本金' htmlFor='companyInfo.capital'>
          <companyInfoFields.capitalField />
        </FormRow>

        <FormRow labelText='社員数' htmlFor='companyInfo.employees'>
          <companyInfoFields.employeesField />
        </FormRow>

        <FormRow labelText='サイトURL' htmlFor='companyInfo.websiteUrl'>
          <companyInfoFields.websiteUrlField />
        </FormRow>

        <FormRow
          isRequired
          isPublic
          labelText='業種区分'
          htmlFor='companyInfo.industryKbnId'
        >
          <companyInfoFields.industryKbnField />
        </FormRow>

        <FormRow labelText='企業カテゴリ'>
          <companyInfoFields.categoriesField />
        </FormRow>

        <FormRow isRequired labelText='ビジネスカテゴリ'>
          <companyInfoFields.businessCategoriesField />
        </FormRow>
      </div>
    </section>
  );
}
